import {
  TRANSACTION_METHODS_NAME_MAP,
  TRANSACTION_STATUS_NAME_MAP,
  TRANSACTION_TYPES,
  TRANSACTION_TYPES_NAME_MAP,
} from '../../../data/types/transactions';
import { Transaction } from '../../../data/types/transactions';

export const getTransactionTypeOptionsFromTransactions = (
  transactions: Transaction[],
) => {
  const getTransactionTypeOptions = (transactions: Transaction[]) => {
    if (!transactions) return [];
    return transactions
      .map((item) => item.transaction_type)
      .filter((value, index, self) => self.indexOf(value) === index); // get unique elements only
  };
  if (!transactions) return [];
  return getTransactionTypeOptions(transactions).map((item) => ({
    label: TRANSACTION_TYPES_NAME_MAP[item],
    value: item,
  }));
};

export const getTransactionMethodOptionsFromTransactions = (
  transactions: Transaction[],
) => {
  const getTransactionMethodOptions = (transactions: Transaction[]) => {
    if (!transactions) return [];
    return transactions
      .map((item) => item.transaction_method)
      .filter((value, index, self) => self.indexOf(value) === index); // get unique elements only
  };
  if (!transactions) return [];
  return getTransactionMethodOptions(transactions).map((item) => ({
    label: TRANSACTION_METHODS_NAME_MAP[item],
    value: item,
  }));
};

export const getStatusOptionsFromTransactions = (
  transactions: Transaction[],
) => {
  const getStatusOptions = (transactions: Transaction[]) => {
    if (!transactions) return [];
    return transactions
      .map((item) => item.transaction_status)
      .filter((value, index, self) => self.indexOf(value) === index); // get unique elements only
  };
  if (!transactions) return [];
  return getStatusOptions(transactions).map((item) => ({
    label: TRANSACTION_STATUS_NAME_MAP[item],
    value: item,
  }));
};

export const getTransactioTypeAmountColor = (type: number) => {
  switch (type) {
    case TRANSACTION_TYPES.driver_company_transaction:
    case TRANSACTION_TYPES.company_store_debt:
    case TRANSACTION_TYPES.company_driver_debt:
      return 'negative-amount'; // Increase Silal Debt

    case TRANSACTION_TYPES.customer_driver_transaction:
    case TRANSACTION_TYPES.company_store_transaction:
    case TRANSACTION_TYPES.company_driver_transaction:
      return 'positive-amount'; // Decrease Silal Debt

    default:
      return 'pending-amount';
  }
};

export const getTransactioTypeCashBalanceColor = (type: number) => {
  switch (type) {
    case TRANSACTION_TYPES.driver_company_transaction:
      return 'negative-amount'; // Increase Silal Debt

    case TRANSACTION_TYPES.customer_driver_transaction:
      return 'positive-amount'; // Decrease Silal Debt

    default:
      return 'pending-amount';
  }
};
